/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  TOGGLE_ITEM_IN_WISH_LIST (state, item) {
    const index = state.wishList.findIndex(i => i.code === item.code);
    if (index < 0) {
      state.wishList.push(item);
    } else {
      state.wishList.splice(index, 1);
    }
  },
  RECALCULATE_CART_PRICES (state, productGroups) {
    if (state.cartItems.length > 0) {
      productGroups.forEach(group => {
        let price = -1;
        const qty = state.cartItems.map(item => item.group == group.code ? item.quantity : 0).reduce((prev, next) => prev + next);
        if (qty >= group.minimumQuantity) {
          price = group.discountedPrice;
        } else {
          price = group.price;
        }
        state.cartItems.forEach(item => {
          if (item.group == group.code) {
            if (price >= 0) {
              item.price = price;
            }
            item.amount = Math.round(item.quantity * item.price * 100) / 100;
          }
        });
      });
    }
  },
  REMOVE_ITEM_FROM_CART (state, item) {
    const index = state.cartItems.findIndex(i => i.code === item.code);
    if (index > -1) { state.cartItems.splice(index, 1) }
    // if (item.group != '') {
    //   let price = item.originalPrice;
    //   let min = 999999;
    //   let qty = 0;
    //   for (let i=0; i < state.cartItems.length; i++) {
    //     if (state.cartItems[i].group == item.group) {
    //       qty += state.cartItems[i].quantity;
    //       min =  state.cartItems[i].minimumPrice2;
    //     }
    //   }
    //   if (qty >= min) {
    //     price = item.price2;
    //   }
    //   for (let i=0; i < state.cartItems.length; i++) {
    //     if (state.cartItems[i].group == item.group) {
    //       state.cartItems[i].price = price;
    //       state.cartItems[i].amount = Math.round(state.cartItems[i].quantity * price * 100) / 100;
    //     }
    //   }
    // }
  },
  ADD_ITEM_IN_CART (state, item) {
    // let price = item.originalPrice;
    // if (item.group != '') {
    //   let min = 999999;
    //   let qty = 0;
    //   for (let i=0; i < state.cartItems.length; i++) {
    //     if (state.cartItems[i].group == item.group) {
    //       qty += state.cartItems[i].quantity;
    //       min =  state.cartItems[i].minimumPrice2;
    //     }
    //   }
    //   qty += item.quantity;
    //   if (qty >= min) {
    //     price = item.price2;
    //   }
    //   for (let i=0; i < state.cartItems.length; i++) {
    //     if (state.cartItems[i].group == item.group) {
    //       state.cartItems[i].price = price;
    //       state.cartItems[i].amount = Math.round(state.cartItems[i].quantity * price * 100) / 100;
    //     }
    //   }
    // }
    // item.price = price;
    item.amount = Math.round(item.quantity * item.price * 100) / 100;
    state.cartItems.push(Object.assign({}, item));
  },
  UPDATE_ITEM_QUANTITY (state, payload) {
    state.cartItems[payload.index].quantity = payload.quantity;
    state.cartItems[payload.index].amount = Math.round(state.cartItems[payload.index].quantity * state.cartItems[payload.index].price * 100) / 100;
  },
  UPDATE_ITEM_QUANTITY_BAK (state, payload) {
    const item = state.cartItems[payload.index];
    let price = item.originalPrice;
    // if (state.cartItems[payload.index].hasOwnProperty('quantityPrice2') && state.cartItems[payload.index].hasOwnProperty('price2')) {
    //   if (payload.quantity >= state.cartItems[payload.index].quantityPrice2) {
    //     price = state.cartItems[payload.index].price2;
    //   }
    // }
    state.cartItems[payload.index].quantity = payload.quantity;
    state.cartItems[payload.index].amount = Math.round(state.cartItems[payload.index].quantity * price * 100) / 100;
    if (item.group != '') {
      let min = 999999;
      let qty = 0;
      for (let i=0; i < state.cartItems.length; i++) {
        if (state.cartItems[i].group == item.group) {
          qty += state.cartItems[i].quantity;
          min =  state.cartItems[i].minimumPrice2;
        }
      }
      if (qty >= min) {
        price = item.price2;
      }
      for (let i=0; i < state.cartItems.length; i++) {
        if (state.cartItems[i].group == item.group) {
          state.cartItems[i].price = price;
          state.cartItems[i].amount = Math.round(state.cartItems[i].quantity * price * 100) / 100;
        }
      }
      state.cartItems[payload.index].quantity = payload.quantity;
      state.cartItems[payload.index].amount = Math.round(state.cartItems[payload.index].quantity * price * 100) / 100;
    }
  }
}

